import { fr, de, enUS, it } from 'date-fns/locale';

export function getDateLocale(lang: string | undefined) {
  return { fr, de, en: enUS, it }[lang ?? 'fr'] ?? fr;
}
